const r = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], s = (t, e = { includeDay: !0 }) => {
  t = new Date(t);
  const o = t.getDate(), a = t.getMonth(), c = t.getFullYear(), n = [r[a], c];
  return e.includeDay && n.unshift(o), n.join(" ");
};
export {
  s as default
};
